// Routes
export const HOME = '/';
export const PRICING = '/pricing';
export const REQUESTDEMO = '/request-demo';
export const PRIVACY = '/privacy';





// WEBPACK FOOTER //
// ./config/constants.js